import type { LanguageTexts } from './types';

export const hr: LanguageTexts = {
  consentTitle: 'Kolačići na ovoj stranici',
  consentDescription:
    'Koristimo nužne kolačiće bez kojih stranica ne radi. Uz vašu privolu koristili bismo i kolačiće za {purposes}, uključujući kolačiće trećih strana. Svoj izbor možete u bilo kojem trenutku promijeniti ili povući gumbom u donjem kutu stranice.',
  consentDescriptionNecessaryOnly:
    'Koristimo samo nužne kolačiće bez kojih stranica ne radi. Za njih privola nije potrebna.',
  controllerLine: 'Voditelj obrade: {controller}.',
  acceptAll: 'Prihvati sve',
  rejectAll: 'Odbij sve',
  preferences: 'Postavke',
  save: 'Spremi izbor',
  close: 'Zatvori',
  serviceCounter: 'usluga|usluge',
  preferencesTitle: 'Postavke kolačića',
  introTitle: 'Kako koristimo kolačiće',
  introDescription:
    'Kolačići su male datoteke koje stranica sprema u vaš preglednik. U nastavku odaberite koje dopuštate. Nužni kolačići uvijek su uključeni.',
  necessaryTitle: 'Nužni kolačići',
  necessaryDescription:
    'Potrebni su za siguran rad stranice i za pamćenje vašeg izbora o kolačićima. Za njih privola nije potrebna.',
  categories: {
    functional: {
      title: 'Funkcionalni kolačići',
      description: 'Omogućuju dodatne funkcije, primjerice ugrađene karte i zapamćene postavke.',
      purpose: 'dodatne funkcije',
    },
    analytics: {
      title: 'Analitički kolačići',
      description:
        'Pomažu nam razumjeti kako posjetitelji koriste stranicu (primjerice koje su stranice najposjećenije) kako bismo je poboljšali.',
      purpose: 'mjerenje posjeta',
    },
    marketing: {
      title: 'Oglašivački kolačići',
      description:
        'Koriste ih oglašivački partneri i pružatelji ugrađenih sadržaja (primjerice videozapisa) za prikaz relevantnijih oglasa i mjerenje njihove uspješnosti. Mogu pratiti vaše posjete i na drugim stranicama.',
      purpose: 'oglašavanje',
    },
  },
  moreTitle: 'Više informacija',
  moreDescription: 'Više o kolačićima i vašim pravima pročitajte u {policyLink}.',
  policyLinkText: 'pravilima o kolačićima',
  policyTitle: 'Pravila o kolačićima',
  and: 'i',
  poweredBy: 'Omogućuje',
  revisitLabel: 'Postavke kolačića',
  iframeNotice: 'Za prikaz ovog sadržaja potrebna je privola za kategoriju „{category}”.',
  iframeButton: 'Dopusti i prikaži',
  tableName: 'Kolačić',
  tableProvider: 'Pružatelj',
  tablePurpose: 'Svrha',
  tableDuration: 'Trajanje',
  session: 'Sesija',
  consentCookiePurpose: 'Sprema vaš izbor o kolačićima.',
  otherCookiesTitle: 'Ostali kolačići',
  otherCookiesNote: 'Kolačići ove stranice koje Kockica ne prepoznaje. Za pojedinosti se obratite voditelju obrade.',
  noCookies: 'Na ovoj stranici nisu otkriveni kolačići za koje je potrebna privola.',
};
